var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPercent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 -960 960 960"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M300-520q-58 0-99-41t-41-99 41-99 99-41 99 41 41 99-41 99-99 41m0-80q25 0 42.5-17.5T360-660t-17.5-42.5T300-720t-42.5 17.5T240-660t17.5 42.5T300-600m360 440q-58 0-99-41t-41-99 41-99 99-41 99 41 41 99-41 99-99 41m0-80q25 0 42.5-17.5T720-300t-17.5-42.5T660-360t-42.5 17.5T600-300t17.5 42.5T660-240m-444 80-56-56 584-584 56 56z"
})));
export default SvgIconPercent;